import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setNomeAdministracaoConsultaAtaRegistroPreco: ['nomeAdministracao'],
    setAtivoConsultaAtaRegistroPreco: ['ativo'],
    setExercicioConsultaAtaRegistroPreco: ['exercicio'],
    setNumeroConsultaAtaRegistroPreco: ['numero'],
    setExercicioLicitacaoConsultaAtaRegistroPreco: ['exercicioLicitacao'],
    setNumeroLicitacaoConsultaAtaRegistroPreco: ['numeroLicitacao'],
    setObjetoConsultaAtaRegistroPreco: ['objeto'],
    limpaFiltroConsultaAtaRegistroPreco: [],
    receberFiltroConsultaAtaRegistroPreco: ['filtroRecebido'],
    setStatusConsultaAtaRegistroPreco: ['status'],
    setDataFimInicialConsultaAtaRegistroPreco: ['dataFimInicial'],
    setDataFimFinalConsultaAtaRegistroPreco: ['dataFimFinal'],
})

const INITIAL_STATE = {
    administracao: [],
    ativo: '',
    exercicio: new Date().getFullYear(),
    numero: '',
    exercicioLicitacao: '',
    numeroLicitacao: '',
    objeto: '',
    dataFimInicial: '',
    dataFimFinal: '',
    status: { label: '', value: '' },
}

const setNomeAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.nomeAdministracao }
}

const setAtivo = (state = INITIAL_STATE, action) => {
    return { ...state, ativo: action.ativo }
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setNumero = (state = INITIAL_STATE, action) => {
    return { ...state, numero: action.numero }
}

const setExercicioLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacao: action.exercicioLicitacao }
}

const setNumeroLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacao: action.numeroLicitacao }
}

const setObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: action.objeto }
}

const setDataFimInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataFimInicial: action.dataFimInicial }
}
const setDataFimFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataFimFinal: action.dataFimFinal }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_DATA_FIM_INICIAL_CONSULTA_ATA_REGISTRO_PRECO]: setDataFimInicial,
    [Types.SET_DATA_FIM_FINAL_CONSULTA_ATA_REGISTRO_PRECO]: setDataFimFinal,
    [Types.SET_NOME_ADMINISTRACAO_CONSULTA_ATA_REGISTRO_PRECO]: setNomeAdministracao,
    [Types.SET_ATIVO_CONSULTA_ATA_REGISTRO_PRECO]: setAtivo,
    [Types.SET_EXERCICIO_CONSULTA_ATA_REGISTRO_PRECO]: setExercicio,
    [Types.SET_NUMERO_CONSULTA_ATA_REGISTRO_PRECO]: setNumero,
    [Types.SET_EXERCICIO_LICITACAO_CONSULTA_ATA_REGISTRO_PRECO]: setExercicioLicitacao,
    [Types.SET_NUMERO_LICITACAO_CONSULTA_ATA_REGISTRO_PRECO]: setNumeroLicitacao,
    [Types.SET_OBJETO_CONSULTA_ATA_REGISTRO_PRECO]: setObjeto,
    [Types.LIMPA_FILTRO_CONSULTA_ATA_REGISTRO_PRECO]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_ATA_REGISTRO_PRECO]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_ATA_REGISTRO_PRECO]: setStatus,
})
